import { Route, Routes } from "react-router-dom";
import { FullContainer } from "../../components/FullContainer";
import { MapChapter } from "./views/MapChapters";
import { MapMainView } from "./views/MapMainView";

export const MapModule = () => {
  console.info("MapModule render");

  return (
    <FullContainer sx={{ bgcolor: "lightBlu.main" }}>
      <Routes>
        <Route path="/" Component={() => <MapMainView />} />
        <Route
          path="/engin"
          Component={() => <MapChapter chapterPath="/engin" color="primary" />}
        />
        <Route
          path="/exchange"
          Component={() => (
            <MapChapter chapterPath="/exchange" color="secondary" />
          )}
        />
        <Route
          path="/labo"
          Component={() => <MapChapter chapterPath="/labo" color="success" />}
        />
      </Routes>
    </FullContainer>
  );
};
